import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import * as React from "react";
import {Grid} from "@material-ui/core";
import {Button, Typography} from "@mui/material";
import {Markup} from "interweave";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {xs: "90%", sm: 450, md: 480},
    bgcolor: "background.paper",
    border: "none",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};

export default function PaymentAgreeModal({ open, children, sx = {} }) {
    // const handleOpen = () => setOpen(true);


  return (
      <Modal
          open={open}
          closeAfterTransition
          BackdropComponent={Backdrop}
          disableAutoFocus={true}
          BackdropProps={{
            timeout: 500,
          }}
      >
        <Fade in={open}>
          <Box sx={{ ...style, ...sx }}>{children}</Box>
        </Fade>
      </Modal>
  );

    // return (
    //     <Modal
    //         open={open}
    //         closeAfterTransition
    //         BackdropComponent={Backdrop}
    //         disableAutoFocus={true}
    //         BackdropProps={{
    //             timeout: 500,
    //         }}
    //     >
    //         {/*<Fade in={open}>*/}
    //         <Box sx={{...style}}><Grid>
    //             <Typography
    //                 sx={{
    //                     fontSize: "1.2rem",
    //                     fontweight: "bold",
    //                 }}
    //             >
    //                 Terms & Condition
    //             </Typography>
    //         </Grid>
    //             <Grid
    //                 sx={{
    //                     mt: 2,
    //
    //                 }}>
    //                 <Markup content={tnc}></Markup>
    //             </Grid></Box>
    //         <div><Grid container sx={{}} alignItems={"center"} spacing={4}>
    //             <Grid item xs={6}> <Button variant="outlined" onClick={() => {
    //                 setAgreeModal({...agreeModal, isOpen: false, isAgree: false})
    //             }}>
    //                 Cancel
    //             </Button></Grid>
    //             <Grid item xs={6}> <Button variant="contained" onClick={() => {
    //                 setAgreeModal({...agreeModal, isOpen: false, isAgree: true})
    //             }}>
    //                 Agree
    //             </Button></Grid>
    //         </Grid></div>
    //     </Modal>
    // );
}
